import React, { useEffect } from 'react'
import { Grid, Button, makeStyles } from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import { logoutUser } from 'actions/loginActions'
import { useStateValue } from 'context/store'
import { openModalAction } from 'context/reducers/modalReducer'

const useMessageViewStyles = makeStyles(theme => ({
   confirmViewContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(2)
   },
   title: {
      fontSize: 16,
      fontWeight: 'bold',
      marginBottom: theme.spacing(2)
   },
   iconContainer: {
      marginBottom: theme.spacing(2)
   },
   errorIcon: {
      color: '#F01E46',
      fontSize: 48
   },
   successIcon: {
      color: '#37C846',
      fontSize: 48
   },
   message: {
      fontSize: 14,
      textAlign: 'center',
      padding: theme.spacing(0, 3),
      marginBottom: theme.spacing(5)
   },
   button: {
      width: '100%',
      color: 'white',
      backgroundColor: '#3264DC',
      '&:hover': {
         color: 'white',
         backgroundColor: '#3264DC'
      }
   }
}))

const CHANGE_PASSWORD_MODAL_MESSAGE = () =>  <div><div><b>Sesión finalizada</b></div><div style={{marginTop: 20}}>Señor usuario, su contraseña se ha actualizado y hemos cerrado su sesión por seguridad. Por favor, inicie sesión con su nueva clave.</div></div>

function MessageView({ setCurrentView, error, handleClose, title, successMessage }) {
   const classes = useMessageViewStyles()
   const [{ sessionUser = {} }, dispatch ] = useStateValue()

   function onError() {
      setCurrentView('formView')
   }

   async function logOutAndShowPopUp() {
      dispatch(openModalAction({
         icon: 'warning',
         message: CHANGE_PASSWORD_MODAL_MESSAGE(),
         confirmButtonText: 'Entendido',
         hideCloseButton: true
      }))
      await logoutUser(dispatch, sessionUser?.token?.refresh_token)
   }

   useEffect(() => {
      !error && logOutAndShowPopUp()
   }, [])

   return (
      <Grid className={classes.confirmViewContainer}>
         <div className={classes.title}>{title}</div>
         <div className={classes.iconContainer}>
            {error ? (
               <ErrorIcon className={classes.errorIcon} />
            ) : (
               <CheckCircleIcon className={classes.successIcon} />
            )}
         </div>
         <div className={classes.message}>{error ? 'Se presentó un error' : successMessage}</div>
         {error ? (
            <Button className={classes.button} variant={'contained'} onClick={onError}>
               Intentar de nuevo
            </Button>
         ) : (
            <Button className={classes.button} variant={'contained'} onClick={handleClose}>
               Aceptar
            </Button>
         )}
      </Grid>
   )
}

export default MessageView
